import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order } from '../../models/order.model';

import { NavigateService } from './../../services/navigate.service';
import { OrderService } from '../../services/order.service';
import { StatisticsService } from '../../services/statistics.service';

@Component({
  selector: 'app-validate-order',
  templateUrl: './validate-order.component.html',
  styleUrls: ['./validate-order.component.scss']
})
export class ValidateOrderComponent implements OnInit {
  id: string;
  order: Order;
  constructor(
    private activatedRoute: ActivatedRoute,
    private orderService: OrderService,
    public navigate: NavigateService,
    public statisticsService: StatisticsService
  ) {}

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.initOrder();
  }

  initOrder() {
    this.orderService.getValidate(this.id).subscribe(r => (this.order = r));
  }

  validate() {
    this.orderService.validate(this.order.id).subscribe(val => {
      if (val) {
        this.order.internalStatus = 'V';
        this.orderService.refreshHistory();
        this.statisticsService.refreshStatistics();
      }
    });
  }

  invalidate(reason: string) {
    this.orderService.invalidate(this.order.id, reason).subscribe(val => {
      if (val) {
        this.order.internalStatus = 'NV';
        this.orderService.refreshHistory();
        this.statisticsService.refreshStatistics();
      }
    });
  }
}
